/**
 * Created by brad on 12/4/18.
 */
export class ConsoleLogThreadManager {

    public consoleApplicationService;
    public updateInterval = 60;
    public logText = "";
    public transmissionActive = false;
    public refreshInterval;

    public constructor(servicePointer) {
        this.consoleApplicationService = servicePointer;
        this.getLogText();
        this.refreshInterval = this.createInterval(this.updateInterval);
    }

    public getLogText() {
        if(this.transmissionActive === false) {
            this.transmissionActive = true;
            this.consoleApplicationService.getLogText().subscribe(result => {
                this.logText = (JSON.parse(result)).log_text;
            });
            this.transmissionActive = false;
        }
    }

    public createInterval(updateInterval) {
        return setInterval(function(that) {
            that.getLogText();
        }, updateInterval * 1000, this);
    };

    public changeInterval() {
        clearInterval(this.refreshInterval);
        this.refreshInterval = this.createInterval(this.updateInterval);
    };

    public destroyInterval() {
        clearInterval(this.refreshInterval);
    }

}


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/console-applications/ConsoleLogThreadManager.ts